let model = {};

// dữ liệu form
model.dataForm = {
  id: undefined, // optional - Mã tự sinh
  user_id: undefined, // required, ref: user - Mã người sử dụng
  limit: undefined, // required, min: 0 - Số lượng
};
model.tableRules = {
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 20,
  offset: 0,
  sort: "user_id",
  defaultSort: ["user_id", "ascending"],
  fields: "id,user_id,limit",
  filters: "",
  dataSearch: {
    value: {
      user_id: "",
      limit: "",
    },
    operator: {
      user_id: "",
      limit: "",
    },
  },
};

export default model;
